import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const companionImage =
  'https://readdy.ai/api/search-image?query=Premium%20fashion%20product%20styling%20shot%20with%20white%20sneakers%20olive%20green%20hoodie%20and%20cognac%20leather%20crossbody%20bag%20arranged%20on%20a%20warm%20beige%20linen%20fabric%20soft%20natural%20daylight%20editorial%20product%20photography%20high%20detail%20warm%20neutral%20tones&width=800&height=700&seq=companion-01&orientation=landscape';

export default function ShoppingCompanion() {
  const { t } = useTranslation();

  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="overflow-hidden rounded-2xl">
            <img
              src={companionImage}
              alt="AllChinaBuy Spreadsheet curated products"
              className="h-full w-full object-cover"
            />
          </div>

          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary-700">
              {t('companion.badge')}
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              {t('companion.title')}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              <Trans
                i18nKey="companion.p1"
                components={{ strong: <strong className="text-foreground-800" /> }}
              />
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              <Trans
                i18nKey="companion.p2"
                components={{ strong: <strong className="text-foreground-800" /> }}
              />
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              <Trans
                i18nKey="companion.p3"
                components={{ strong: <strong className="text-foreground-800" /> }}
              />
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-900 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-foreground-800 cursor-pointer"
              >
                {t('companion.cta1')}
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
              <Link
                to="/allchinabuy-spreadsheet-guide"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-7 py-3.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
              >
                {t('companion.cta2')}
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}